export default __webpack_public_path__ + "static/media/rhb-b.0cdfa206.svg";